import React from 'react'
import cx from 'classnames'

import styles from './radio-button.module.css'

export function RadioButtonDescription({ children, className }) {
    if (!children) {
        return null
    }

    return <span className={cx(styles['radio-button-description'], className)}>{children}</span>
}
